import { useState, useEffect, useRef, useCallback } from 'react';
import { BaseFormModal } from '@/components/BaseFormModal';
import { focusAfterPaint } from '@/utils/dom';

export interface AddCallSignModalProps {
  open: boolean;
  theme?: string;
  saving?: boolean;
  onSave: (data: { callSign: string }) => void;
  onCancel: () => void;
}

export function AddCallSignModal({
  open,
  theme,
  saving = false,
  onSave,
  onCancel,
}: AddCallSignModalProps) {
  const [callSign, setCallSign] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  // Reset form and focus input when modal opens
  useEffect(() => {
    if (open) {
      setCallSign('');
      focusAfterPaint(inputRef);
    }
  }, [open]);

  const handleSave = useCallback(() => {
    if (!callSign || !callSign.trim()) {
      (window as any).App?.showPopupNotification?.('Call Sign Name required.', 'error');
      return;
    }

    onSave({ callSign: callSign.trim() });
  }, [callSign, onSave]);

  return (
    <BaseFormModal
      open={open}
      title="Add Call Sign"
      theme={theme}
      dialogClass="kstc-dialog--form"
      saveText={saving ? 'Saving...' : 'Add'}
      saveDisabled={saving}
      busy={saving}
      onSave={handleSave}
      onCancel={onCancel}
    >
      <div className="kstc-form-group">
        <label className="kstc-label">Call Sign</label>
        <input
          ref={inputRef}
          type="text"
          className="kstc-input kst-call-sign-input"
          value={callSign}
          onChange={(e) => setCallSign(e.target.value)}
          placeholder="Enter call sign..."
        />
      </div>
    </BaseFormModal>
  );
}

(window as any).AddCallSignModalReact = AddCallSignModal;
